(function () {
  "use strict";

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }

    callback();
  }

  function clampPercent(value) {
    return Math.max(0, Math.min(100, Number(value) || 0));
  }

  function syncPercentFills(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll("[data-fill-width]").forEach(function (element) {
      element.style.width = clampPercent(element.getAttribute("data-fill-width")) + "%";
    });
  }

  function scheduleDeferredTask(callback, timeout) {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(callback, { timeout: timeout || 900 });
      return;
    }

    window.setTimeout(callback, timeout || 250);
  }

  function closestFromEventTarget(target, selector) {
    if (!target) return null;
    var element = target.nodeType === 1 ? target : target.parentElement;
    return element && element.closest ? element.closest(selector) : null;
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[char];
    });
  }

  function safeExternalMapUrl(value) {
    var raw = String(value || "").trim();
    try {
      var url = new URL(raw, window.location.origin);
      var host = url.hostname.toLowerCase();
      if (
        (url.protocol === "https:" || url.protocol === "http:") &&
        (host === "google.com" || host.endsWith(".google.com") || host === "goo.gl")
      ) {
        return url.href;
      }
    } catch (error) {
      void error;
    }
    return "https://www.google.com/maps";
  }

  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;

    try {
      var predictivePanel =
        document.getElementById("predictive-search-panel") ||
        document.getElementById("search-panel");
      if (predictivePanel) {
        predictivePanel.hidden = true;
        predictivePanel.setAttribute("aria-hidden", "true");
      }

      var predictiveInput =
        document.getElementById("predictive-search-input") ||
        document.getElementById("search-q");
      if (predictiveInput) predictiveInput.value = "";

      var stickyCart = document.getElementById("sticky-cart");
      if (stickyCart) stickyCart.setAttribute("data-visible", "false");

      var miniNav = document.getElementById("mini-nav");
      if (miniNav) miniNav.setAttribute("data-visible", "false");

      var mobileMenu = document.querySelector('[data-mobile-menu][data-open="true"]');
      if (mobileMenu) {
        mobileMenu.setAttribute("data-open", "false");
        mobileMenu.setAttribute("aria-hidden", "true");
      }

      var mobileMenuToggle = document.querySelector("[data-mobile-menu-toggle]");
      if (mobileMenuToggle) {
        mobileMenuToggle.setAttribute("aria-expanded", "false");
        mobileMenuToggle.setAttribute(
          "aria-label",
          mobileMenuToggle.getAttribute("data-label-open") || "Open menu"
        );
      }

      var mobileMenuIcon = document.querySelector("[data-mobile-menu-icon]");
      if (mobileMenuIcon) mobileMenuIcon.textContent = "menu";

      document.documentElement.classList.remove("mobile-menu-open");
      if (document.body) document.body.classList.remove("mobile-menu-open");

      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    } catch (error) {
      void error;
    }
  });

  function labelPreviewFrame() {
    var previewFrame = document.getElementById("PBarNextFrame");
    if (previewFrame && !previewFrame.getAttribute("title")) {
      previewFrame.setAttribute("title", "Shopify preview bar");
    }
    return !!previewFrame;
  }

  (function watchPreviewFrame() {
    if (labelPreviewFrame()) return;
    if (!("MutationObserver" in window)) {
      window.setTimeout(labelPreviewFrame, 1200);
      return;
    }

    var observer = new MutationObserver(function () {
      if (!labelPreviewFrame()) return;
      observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
      labelPreviewFrame();
    }, 6000);
  })();

  scheduleDeferredTask(function () {
    try {
      var visits = parseInt(localStorage.getItem("theme_visits") || "0", 10) + 1;
      localStorage.setItem("theme_visits", String(visits));
      localStorage.setItem("theme_last_visit", String(Date.now()));
    } catch (error) {
      void error;
    }
  }, 1500);

  try {
    var params = new URLSearchParams(window.location.search);
    var campaign = params.get("campaign") || params.get("context");
    if (campaign) {
      var rawMap = document.documentElement.getAttribute("data-campaign-map");
      if (rawMap) {
        var campaignMap = JSON.parse(rawMap);
        var config = campaignMap && campaignMap[campaign];
        if (config) {
          var root = document.documentElement;
          if (config.primary) root.style.setProperty("--brand-primary", config.primary);
          if (config.primaryInk) root.style.setProperty("--brand-primary-ink", config.primaryInk);
          if (config.surface) root.style.setProperty("--brand-surface", config.surface);
          if (config.cta) root.style.setProperty("--brand-cta", config.cta);
          document.body.setAttribute("data-campaign", campaign);
        }
      }
    }
  } catch (error) {
    void error;
  }

  onReady(function () {
    if (window.location.pathname.indexOf("/account") === -1) return;
    if (window.location.hash !== "#orders") return;

    var orderLink = document.querySelector("[data-mobile-orders-link]");
    var accountLink = document.querySelector("[data-mobile-account-link]");

    if (orderLink) {
      orderLink.classList.add("is-active");
      orderLink.setAttribute("aria-current", "page");
    }

    if (accountLink) {
      accountLink.classList.remove("is-active");
      accountLink.removeAttribute("aria-current");
    }
  });

  onReady(function () {
    if (!document.querySelector("[data-fill-width]")) return;
    syncPercentFills(document);
  });

  onReady(function () {
    var aboutRoot = document.querySelector(".content-page--about .page-rte");
    if (!aboutRoot || aboutRoot.querySelector(".about-map-card")) return;

    var mapFrame = aboutRoot.querySelector('iframe[src*="google.com/maps"]');
    if (!mapFrame) return;

    var host = mapFrame.closest("p") || mapFrame.parentElement;
    if (!host) return;

    var introParagraph = host.previousElementSibling;
    if (
      introParagraph &&
      introParagraph.tagName === "P" &&
      /地図で見る|こんなところ/.test(introParagraph.textContent || "")
    ) {
      introParagraph.remove();
    }

    var mapUrl = safeExternalMapUrl(mapFrame.getAttribute("src") || mapFrame.src || "");

    var card = document.createElement("section");
    card.className = "about-map-card";
    card.innerHTML =
      '<div class="about-map-card__media">' +
        '<div class="about-map-card__pin">' +
          '<span class="ms xl" aria-hidden="true">location_on</span>' +
          "<strong>店舗までのアクセス</strong>" +
          "<small>地図を開いて道順と周辺の様子を確認できます。</small>" +
        "</div>" +
      "</div>" +
      '<div class="about-map-card__body">' +
        '<p class="about-map-card__eyebrow">アクセス</p>' +
        '<h2 class="about-map-card__title">店舗の場所を地図で確認</h2>' +
        '<p class="about-map-card__lead">別タブで Google マップを開いて、ルート案内や周辺の様子をすぐ確認できます。</p>' +
        '<div class="about-map-card__actions">' +
          '<a class="about-map-card__link" href="' + escapeHtml(mapUrl) + '" target="_blank" rel="noopener noreferrer">' +
            '<span class="ms sm" aria-hidden="true">map</span>Googleマップで開く' +
          "</a>" +
        "</div>" +
      "</div>";

    host.replaceWith(card);
  });

  function initRail(root) {
    if (!root || root.getAttribute("data-rail-enhanced") === "true") return;
    root.setAttribute("data-rail-enhanced", "true");

    var track = root.querySelector("[data-rail-track]");
    var prev = root.querySelector("[data-rail-prev]");
    var next = root.querySelector("[data-rail-next]");
    if (!track) return;
    var syncFrame = 0;

    function stepSize() {
      return Math.max(track.clientWidth * 0.72, 240);
    }

    function syncButtons() {
      var maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth - 4, 0);
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= maxScrollLeft;

      if (prev) {
        prev.disabled = atStart;
        prev.setAttribute("aria-disabled", String(atStart));
      }

      if (next) {
        next.disabled = atEnd;
        next.setAttribute("aria-disabled", String(atEnd));
      }
    }

    function scheduleSyncButtons() {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(function () {
        syncFrame = 0;
        syncButtons();
      });
    }

    if (prev) {
      prev.addEventListener("click", function () {
        track.scrollBy({ left: -stepSize(), behavior: "smooth" });
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        track.scrollBy({ left: stepSize(), behavior: "smooth" });
      });
    }

    track.addEventListener("scroll", scheduleSyncButtons, { passive: true });
    window.addEventListener("resize", scheduleSyncButtons);
    syncButtons();
  }

  onReady(function () {
    var rails = document.querySelectorAll("[data-rail-root]");
    if (!rails.length) return;

    if (!("IntersectionObserver" in window)) {
      rails.forEach(initRail);
      return;
    }

    var railObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          railObserver.unobserve(entry.target);
          initRail(entry.target);
        });
      },
      { rootMargin: "320px 0px" }
    );

    rails.forEach(function (rail) {
      railObserver.observe(rail);
    });
  });

  onReady(function () {
    var menu = document.querySelector("[data-mobile-menu]");
    var toggle = document.querySelector("[data-mobile-menu-toggle]");
    if (!menu || !toggle) return;

    var icon = toggle.querySelector("[data-mobile-menu-icon]");
    var closeTriggers = menu.querySelectorAll("[data-mobile-menu-close]");
    var closeButton = menu.querySelector(".ybar-mobile-menu__close");
    var desktopQuery = window.matchMedia ? window.matchMedia("(min-width: 769px)") : null;

    function setMobileMenuOpen(isOpen) {
      menu.setAttribute("data-open", isOpen ? "true" : "false");
      menu.setAttribute("aria-hidden", isOpen ? "false" : "true");
      toggle.setAttribute("aria-expanded", String(isOpen));
      toggle.setAttribute(
        "aria-label",
        isOpen
          ? toggle.getAttribute("data-label-close") || "Close menu"
          : toggle.getAttribute("data-label-open") || "Open menu"
      );

      if (icon) icon.textContent = isOpen ? "close" : "menu";

      document.documentElement.classList.toggle("mobile-menu-open", isOpen);
      if (document.body) document.body.classList.toggle("mobile-menu-open", isOpen);

      if (isOpen && closeButton) {
        window.setTimeout(function () {
          closeButton.focus({ preventScroll: true });
        }, 40);
      }
    }

    toggle.addEventListener("click", function () {
      setMobileMenuOpen(menu.getAttribute("data-open") !== "true");
    });

    closeTriggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        setMobileMenuOpen(false);
        toggle.focus({ preventScroll: true });
      });
    });

    menu.addEventListener("click", function (event) {
      var closeTrigger = closestFromEventTarget(event.target, "[data-mobile-menu-close]");
      if (closeTrigger) {
        event.preventDefault();
        event.stopPropagation();
        setMobileMenuOpen(false);
        toggle.focus({ preventScroll: true });
        return;
      }

      var link = closestFromEventTarget(event.target, "a");
      if (!link) return;
      setMobileMenuOpen(false);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || menu.getAttribute("data-open") !== "true") return;
      setMobileMenuOpen(false);
      toggle.focus({ preventScroll: true });
    });

    if (desktopQuery) {
      var closeOnDesktop = function () {
        if (desktopQuery.matches) setMobileMenuOpen(false);
      };

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener("change", closeOnDesktop);
      } else if (desktopQuery.addListener) {
        desktopQuery.addListener(closeOnDesktop);
      }
    }
  });

  var cartRuntimePromise = null;

  function cartRuntimeUrl() {
    if (window.themeAssets && window.themeAssets.cartRuntime) {
      return window.themeAssets.cartRuntime;
    }

    var scriptNode = document.querySelector("[data-cart-runtime-src]");
    return scriptNode ? scriptNode.getAttribute("data-cart-runtime-src") : "";
  }

  function isCartRuntimeReady() {
    return !!(window.ThemeCartUI && window.ThemeCartUI.ready);
  }

  function hasCartEnhancements() {
    return !!document.querySelector(
      "[data-mini-cart-drawer], form[data-ajax-cart-form]"
    );
  }

  function loadCartRuntime() {
    if (isCartRuntimeReady()) {
      return Promise.resolve(window.ThemeCartUI);
    }

    if (cartRuntimePromise) {
      return cartRuntimePromise;
    }

    var src = cartRuntimeUrl();
    if (!src) {
      return Promise.reject(new Error("cart runtime asset missing"));
    }

    cartRuntimePromise = new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.onload = function () {
        resolve(window.ThemeCartUI || {});
      };
      script.onerror = function () {
        cartRuntimePromise = null;
        reject(new Error("cart runtime failed to load"));
      };
      document.body.appendChild(script);
    });

    return cartRuntimePromise;
  }

  onReady(function () {
    if (!hasCartEnhancements()) return;

    var preloadSelector =
      "[data-mini-cart-open], form[data-ajax-cart-form]";
    var warmed = false;
    var shouldWarmOnIdle =
      !!document.body &&
      (document.body.classList.contains("template-product") ||
        document.body.classList.contains("page-product"));

    function warmCartRuntime() {
      if (warmed || isCartRuntimeReady()) return;
      warmed = true;
      loadCartRuntime().catch(function () {
        warmed = false;
      });
    }

    if (shouldWarmOnIdle) {
      scheduleDeferredTask(warmCartRuntime, 1400);
    }

    document.addEventListener(
      "pointerenter",
      function (event) {
        if (!closestFromEventTarget(event.target, preloadSelector)) return;
        warmCartRuntime();
      },
      true
    );

    document.addEventListener("focusin", function (event) {
      if (!closestFromEventTarget(event.target, preloadSelector)) return;
      warmCartRuntime();
    });

    document.addEventListener(
      "touchstart",
      function (event) {
        if (!closestFromEventTarget(event.target, preloadSelector)) return;
        warmCartRuntime();
      },
      { passive: true, capture: true }
    );
  });

  onReady(function () {
    if (!hasCartEnhancements()) return;

    document.addEventListener(
      "click",
      function (event) {
        if (isCartRuntimeReady()) return;

        var openTrigger = closestFromEventTarget(event.target, "[data-mini-cart-open]");
        if (openTrigger) {
          if (window.location.pathname.indexOf("/cart") !== -1) return;
          event.preventDefault();
          loadCartRuntime()
            .then(function (cartUi) {
              if (cartUi && typeof cartUi.openDrawer === "function") {
                cartUi.openDrawer();
              }
            })
            .catch(function () {
              window.location.href = openTrigger.href;
            });
          return;
        }

        return;
      },
      true
    );

    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (!form || !form.matches("form[data-ajax-cart-form]") || isCartRuntimeReady()) {
          return;
        }

        event.preventDefault();
        loadCartRuntime()
          .then(function (cartUi) {
            if (cartUi && typeof cartUi.submitAjaxForm === "function") {
              cartUi.submitAjaxForm(form);
              return;
            }
            form.submit();
          })
          .catch(function () {
            form.submit();
          });
      },
      true
    );
  });
})();
